import React from 'react';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { useAttributeFormBuilder } from '../../../../Hooks/Display/useComponentProperties';
import CreateStep from './CreateStep';
import StepLayout from './StepLayout';
import Step from './Step';

const Steps = ({ draggedAttributeId, onDropAttribute }) => {

    const [{ steps, selectedStepId }, dispatch] = useAttributeFormBuilder();

    const handleSelectedStep = (e) => {
        const Step = steps[e.selected];
        dispatch.setSelectedStep(Step.id)
    };

    return (
        <>
            <CreateStep />
            {
                steps.length > 0 &&
                <TabStrip
                    selected={steps.findIndex(step => step.id === selectedStepId)}
                    onSelect={handleSelectedStep}
                >
                    {steps.map((step) => (
                        <TabStripTab
                            title={<Step step={step} />}
                        >
                            <StepLayout draggedAttributeId={draggedAttributeId} onDropAttribute={onDropAttribute} />
                        </TabStripTab>
                    ))}
                </TabStrip>
            }
        </>
    );
};

export default Steps;